export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT = "LOGOUT";

export const SHOW_DATE_QUERY_INPUT = "SHOW_DATE_QUERY_INPUT";
export const HIDE_DATE_QUERY_INPUT = "HIDE_DATE_QUERY_INPUT";